import { render, staticRenderFns } from "./KimsaFile.vue?vue&type=template&id=238337c2&scoped=true&"
import script from "./KimsaFile.vue?vue&type=script&lang=js&"
export * from "./KimsaFile.vue?vue&type=script&lang=js&"
import style0 from "./KimsaFile.vue?vue&type=style&index=0&id=238337c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238337c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFileInput,VIcon})
